// extracted by mini-css-extract-plugin
export default {"spinner":"AttenteRequete_spinner__zKuCx"};